import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { CommunityImage } from 'components'
import { LEARNING_HUB_ROUTE } from 'config'
import { get } from 'lodash'
import homeIcon from 'images/side-navigation/home.svg'
import directoryIcon from 'images/side-navigation/directory.svg'
import communityIcon from 'images/side-navigation/community.svg'
import forumIcon from 'images/side-navigation/connect.svg'
import userIcon from 'images/side-navigation/user.svg'
import faqIcon from 'images/side-navigation/faq.svg'

const propTypes = {
  community: PropTypes.object.isRequired,
  entityHomeRoute: PropTypes.string.isRequired,
  closeMobileNav: PropTypes.func.isRequired,
}

const NAV_LINKS = [
  { to: `${LEARNING_HUB_ROUTE}/home`, label: 'Home', icon: homeIcon },
  {
    to: `${LEARNING_HUB_ROUTE}/course-catalog`,
    label: 'Course Catalog',
    icon: directoryIcon,
  },
  {
    to: `${LEARNING_HUB_ROUTE}/my-courses`,
    label: 'My Courses',
    icon: communityIcon,
  },
  { to: `${LEARNING_HUB_ROUTE}/forum`, label: 'Forum', icon: forumIcon },
  {
    to: `${LEARNING_HUB_ROUTE}/my-profile`,
    label: 'My Profile',
    icon: userIcon,
  },
  { to: `${LEARNING_HUB_ROUTE}/faq`, label: 'FAQ', icon: faqIcon },
]

function LearningHubSecondaryNav({ community, closeMobileNav }) {
  const { name: communityName, defaultBranding } = community
  const communityLogo = get(defaultBranding, 'communityLogo')
  const title = `${communityName}'s artlook Learning Hub`

  return (
    <nav
      className="side-navigation side-navigation--learning-hub"
      aria-label="Learning Hub navigation"
    >
      <div className="side-navigation-inner">
        <div className="learning-hub-nav-head">
          <h2 className="learning-hub-title">{title}</h2>
          <div className="learning-hub-logo-block">
            <CommunityImage image={communityLogo} />
          </div>
        </div>
        <ul>
          {NAV_LINKS.map(({ to, label, icon }) => (
            <li key={to}>
              <Link
                to={to}
                activeClassName="is-active"
                onClick={closeMobileNav}
              >
                <img src={icon} alt="" />
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}

LearningHubSecondaryNav.propTypes = propTypes

export default LearningHubSecondaryNav
